import { render, staticRenderFns } from "./CoverPageComments.vue?vue&type=template&id=0cae59e9&scoped=true&"
import script from "./CoverPageComments.vue?vue&type=script&lang=js&"
export * from "./CoverPageComments.vue?vue&type=script&lang=js&"
import style0 from "./CoverPageComments.vue?vue&type=style&index=0&id=0cae59e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cae59e9",
  null
  
)

export default component.exports